import React from "react";
import JsonViewer from "../utilities/tabs/jsonViewer";

class JsonViewerModal extends React.Component {
  constructor(props) {
    super(props);

    this.mainInput = HTMLTextAreaElement;
    this.modal = HTMLDivElement;

    this.tryParse = this.tryParse.bind(this);
    this.handleButton = this.handleButton.bind(this);

    let { value, enforceArgs } = this.props;
  }

  tryParse(data) {
    try {
      JSON.parse(data);
    } catch (e) {
      return false;
    }
    return data;
  }

  handleButton() {
   
  }

  render() {
    // jquery selectors need escaping when it includes dot or brace character
    let safeId = this.props.id && this.props.id.replace(/\[|\]|\./g, "");

    let unparsedVal = this.props.value;

    let parseVal = this.tryParse(unparsedVal);

    return (
      <div className="code-editor-modal btn-group" role="group">
        {/* <button type="button" className="btn btn-sm btn-warning ml-1" title={this.props.buttonTitle || "edit"} onClick={this.handleModalToggle} data-target={`#${safeId}-modal`} data-backdrop="false">
                    {this.props.buttonText || <i className="fas fa-edit"></i>}
                </button> */}
        <button
          type="button"
          class="btn btn-primary"
          data-toggle="modal"
          data-target={`#modal-${this.props.index}`}
          data-backdrop="true"
          onClick={this.handleButton}
        >
          {this.props.buttonText || <i className="fas fa-edit"></i>}
        </button>

        <div
          className="modal fade in"
          id={`modal-${this.props.index}`}
          tabIndex="5"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Error
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  {/* {unparsedVal} */}
                  {parseVal ? (
                    <JsonViewer value={parseVal} name={"data"} />
                  ) : (
                      unparsedVal
                    )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// CodeEditorModal.propTypes = {
//     id: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired,
//     value: PropTypes.array.isRequired
// }

export default JsonViewerModal;



// WEBPACK FOOTER //
// ./src/components/utilities/JsonViewerModal.js